import { forwardRef, type Ref, type SVGProps } from "react";
const IconYardSignOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 6H8V2.93a1 1 0 0 0-2 0V6H2.89a1 1 0 0 0 0 2H6v21.06A1 1 0 0 0 7 30a1 1 0 0 0 1-.93V8h4v2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2V8h3a1 1 0 0 0 0-2m-3 15H12v-9h14Zm-2-11H14V8h10Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconYardSignOutlineSVG);
ForwardRef.displayName = "IconYardSignOutline";
export { ForwardRef as IconYardSignOutline };
